<template>
<div class="footer">
   <div class="social_icons">
      <a href="https://www.facebook.com/tikibistro/" target="_blank"><font-awesome-icon :icon="{ prefix: 'fab', iconName: 'facebook-f' }" class="icon_footer"/></a>
      <a href="https://www.tripadvisor.com/Restaurant_Review-g304060-d8650870-Reviews-Tiki_Bistro-Iasi_Iasi_County_Northeast_Romania.html"><font-awesome-icon :icon="{ prefix: 'fab', iconName: 'tripadvisor' }" class="icon_footer"/></a>
      <a href="https://www.instagram.com/tikibistro/"><font-awesome-icon :icon="{ prefix: 'fab', iconName: 'instagram' }" class="icon_footer"/></a>
      <!-- <a href="/about"><font-awesome-icon :icon="{ prefix: 'fab', iconName: 'pinterest-p' }" class="icon_footer"/></a> -->
    </div>
    <div class="footer_bottom">
      <div class="sal_sol flex">
         <a target="_blank" href="https://anpc.ro/ce-este-sal/"><img src="@/assets/images/SAL.png" alt=""/></a>
         <a target="_blank" href="https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&lng=RO"><img src="@/assets/images/SOL.png" alt=""/></a>
      </div>
        <div>Copyright 2026. All Right Reserved</div>
    </div>
    
 </div>
</template>

<script>

export default {
  name: 'Footer',
  data() {
    return {};
  },
  mounted() {
    // no periodic profile check
  },
  methods: {
  },
};
</script>
